var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSquare4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.834 8.80887V14.9993C15.834 15.9198 15.0878 16.666 14.1673 16.666H5.00065C4.08018 16.666 3.33398 15.9198 3.33398 14.9993V5.83268C3.33398 4.91221 4.08018 4.16602 5.00065 4.16602H11.1911",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9993 5.83268C15.4596 5.83268 15.8327 5.45959 15.8327 4.99935C15.8327 4.53911 15.4596 4.16602 14.9993 4.16602C14.5391 4.16602 14.166 4.53911 14.166 4.99935C14.166 5.45959 14.5391 5.83268 14.9993 5.83268Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 12.5L9.16602 9.16667L10.8333 10.8333L13.3327 7.5",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSquare4);
export default __webpack_public_path__ + "static/media/check-square4.d237cbcdbacf828ea3922c6c0608b25e.svg";
export { ForwardRef as ReactComponent };